export enum LogType {
  Api = 10,
  ApiNotification = 11,
  ApiVersion = 12,
  Validation = 13,
  Globalization = 14,
  Performance = 15,
  Scheduler = 16,
  Export = 17,

  WebLog = 30,
  WebException = 31,
  WebMissingTranslation = 32,

  MobileLog = 40,
  MobileException = 41,

  BackendMissingTranslation = 50,
  NotExistingLanguage = 53,

  Stripe = 60,
  Messaging = 61,

  ChatKitException = 70,
}
